module Client.UI

open Fable.React
open Fable.React.Props
open Illy.SafeStack.Client

let private renderValidation validation = 
    //return a div in all cases. This is required to prevent React from re-rendering the DOM tree if validations disappear 
    match validation with 
    | None -> div [ Class "validations-container no-validations clearfix" ] []
    | Some v -> 
        div [ Class "validations-container clearfix" ] [
            yield v
        ]

let renderErrorWithContent renderContent error = 
    error 
    |> Option.map (renderContent >> span [ ClassName "validation ui-state-error" ]) 
    |> renderValidation  

let renderError = renderErrorWithContent (str >> List.singleton) 

let renderWarningWithContent renderContent warning = 
    warning 
    |> Option.map (renderContent >> span [ ClassName "validation ui-state-highlight" ])
    |> renderValidation

let renderWarning = renderWarningWithContent (str >> List.singleton)

let button text onClick dispatch = jQueryUI.buttonWithClass (Some "action-button ui-state-default ui-button-text-only") text onClick dispatch

let buttonWithDisabled disabled text onClick dispatch = jQueryUI.buttonWithDisabled disabled (Some "action-button ui-state-default ui-button-text-only") text onClick dispatch
let buttonWithDisabledAndClasses disabled classes text onClick dispatch = jQueryUI.buttonWithDisabled disabled (Some (sprintf "action-button ui-state-default ui-button-text-only %s" classes)) text onClick dispatch

let saveControls saveButtonName gettingData saving saveClickedMsg cancelMsg dispatch = 
    [
        if not gettingData then
            yield div [ ClassName "saveControls"]
                [
                    if not saving then
                        yield button (FSharp.Core.Option.defaultValue "Save" saveButtonName) saveClickedMsg dispatch
                    else 
                        yield jQueryUI.saveSpinner

                    yield span [] [str "or"]
                    yield a [ OnClick (fun _ -> dispatch cancelMsg) ] [str "Cancel" ]
                ]
    ]